const adminRoutes = [
  {
    path: "/admin",
    name: "admin.index",
    component: () => import("@/modules/admin/views/AdminIndexPage.vue"),
    meta: {
      need_capability: "admin_panel",
      pageTitle: "Administração",
      roles: [1, 2, 5, 6],
      breadcrumb: [
        { text: "Administração", active: true }
      ]
    }
  },
  {
    path: "/admin/notifications",
    name: "admin.notifications.index",
    component: () => import("@/modules/admin/views/NotificationsPage.vue"),
    meta: {
      need_capability: "admin_panel",
      pageTitle: "Notificações",
      roles: [1, 2, 5, 6],
      breadcrumb: [
        { text: "Administração", to: { name: "admin.index" } },
        { text: "Notificações", active: true }
      ]
    }
  },
  {
    path: "/admin/users",
    name: "admin.users.index",
    component: () => import("@/modules/admin/views/UserIndexPage.vue"),
    meta: {
      need_capability: "admin_panel",
      pageTitle: "Usuários",
      roles: [1, 5],
      breadcrumb: [
        { text: "Administração", to: { name: "admin.index" } },
        { text: "Usuários", active: true }
      ]
    }
  },
  {
    path: "/admin/commands",
    name: "admin.commands.index",
    component: () => import("@/modules/admin/views/AdminCommandsPage.vue"),
    meta: {
      need_capability: "admin_panel",
      pageTitle: "Commands",
      roles: [5],
      breadcrumb: [
        { text: "Administração", to: { name: "admin.index" } },
        { text: "Commands", active: true }
      ]
    }
  },
  {
    path: "/admin/tendencias/categorias-ml",
    name: "admin.trend-categories.index",
    component: () => import("@/modules/admin/views/TrendCategoriesAdminPage.vue"),
    meta: {
      pageTitle: "Categorias de Tendências ML",
      roles: [5],
      breadcrumb: [
        { text: "Administração", to: { name: "admin.index" } },
        { text: "Categorias de Tendências ML", active: true }
      ]
    }
  },
  {
    path: "/admin/notifications/orders",
    name: "admin.notifications.orders",
    component: () => import("@/modules/admin/views/OrderNotificationsPage.vue"),
    meta: {
      need_capability: "admin_panel",
      pageTitle: "Notificações de Pedidos",
      roles: [1, 2, 5, 6],
      breadcrumb: [
        { text: "Administração", to: { name: "admin.index" } },
        { text: "Notificações", to: { name: "admin.notifications.index" } },
        { text: "Notificações de Pedidos", active: true }
      ]
    }
  }
];

export default adminRoutes;
